import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Dialog,
  DialogBackdrop,
  DialogContent,
  DialogFooter,
  PrimaryButton,
  TertiaryButton,
} from '@tricor-digital-team/vistra-design-system';
import React, { useEffect, useState } from 'react';
import { z } from 'zod';
import PersonalDetails from './PersonalDetails';
import { updateIndividual } from '../../../../Redux/individualSlice';
import { useDispatch, useSelector } from 'react-redux';

const personalDetailsSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, 'First name is required'), // trims and ensures non-empty
  lastName: z
    .string()
    .trim()
    .min(1, 'Last name is required'),
  middleName: z
    .string()
    .trim()
    .optional(),
  email: z
    .string()
    .trim()
    .email('Invalid email address')
});

const IndividualModal = ({ dialog, individualIndex, selectedIndividual, addIndividualData }) => {
  const dispatch = useDispatch();
  const individualDetails = useSelector((state) => state.individual.individualDetails);
  const [isEditSummary, setIsEditSummary] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [personalDetailsErrors, setPersonalDetailsErrors] = useState({});
  const [resetCount, setResetCount] = useState(0);
  const [personalDetails, setPersonalDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    middleName: '',
  });

  useEffect(() => {
    setCurrentStep(0);
    setPersonalDetailsErrors({});
    setResetCount((prev) => prev + 1);
    setPersonalDetails({
      firstName: '',
      lastName: '',
      email: '',
      middleName: '',
    });
    setIsEditSummary(false);
    if (selectedIndividual) {
      setPersonalDetails(selectedIndividual?.personalDetails);
    }
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [dialog, selectedIndividual]);

  function isEmailUnique(emailToCheck, existingEmail = '') {
    return !individualDetails.some((item) => {
      const currentEmail = item.personalDetails?.email;
      return currentEmail === emailToCheck && currentEmail !== existingEmail;
    });
  }

  const validatePersonalDetails = () => {
    const result = personalDetailsSchema.safeParse(personalDetails);
    if (!result.success) {
      const errorMessages = result.error.format();
      const newErrors = Object.fromEntries(
        Object.entries(errorMessages).map(([key, val]) => [key, val?._errors?.[0] || ''])
      );
      setPersonalDetailsErrors(newErrors);
      return false;
    }
    setPersonalDetailsErrors({});
    return true;
  };

  const validateEmail = (existingEmail = '') => {
    if (individualDetails.length > 0) {
      if (!isEmailUnique(personalDetails.email, existingEmail)) {
        setPersonalDetailsErrors((prevErrors) => ({
          ...prevErrors,
          email: 'Email already exists',
        }));
        return false;
      }
    }
    return true;
  };

  return (
    <DialogBackdrop id="dialog-backdrop" {...dialog}>
      <Dialog
        id="dialog-container"
        hideOnEsc={false}
        hideOnClickOutside={false}
        {...dialog}
        aria-label="Individual Details"
        size={'medium'}
      >
        <DialogContent>
          <PersonalDetails
            resetCount={resetCount}
            personalDetails={personalDetails}
            personalDetailsErrors={personalDetailsErrors}
            setPersonalDetails={setPersonalDetails}
            setPersonalDetailsErrors={setPersonalDetailsErrors}
            selectedIndividual={selectedIndividual?.personalDetails}
            isEditSummary={isEditSummary}
          />
          {/* <div className="text-black text-2xl font-medium">
            {selectedIndividual ? 'View Individual detail' : 'Adding Individual detail'}
          </div>
          {!isFinalStep && (
            <PersonalDetails
              resetCount={resetCount}
              personalDetails={personalDetails}
              personalDetailsErrors={personalDetailsErrors}
              setPersonalDetails={setPersonalDetails}
              setPersonalDetailsErrors={setPersonalDetailsErrors}
              selectedIndividual={selectedIndividual?.personalDetails}
              isEditSummary={isEditSummary}
            />
          )} */}
        </DialogContent>
        <DialogFooter>
          <div className="flex justify-between items-center w-full py-3">
            <TertiaryButton label="Cancel" onClick={() => dialog.hide()} size="large" />
            <div className="flex justify-between gap-6">

              {!isEditSummary ? <PrimaryButton
                icon={ArrowRightIcon}
                iconPosition="right"
                label="Next"
                onClick={(e) => {
                  e.preventDefault();
                  if (!validatePersonalDetails() || !validateEmail(selectedIndividual?.personalDetails?.email)) return;

                  setIsEditSummary(true);
                }}
                size="large"
              /> : <PrimaryButton
                label="Confirm edit"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(
                    updateIndividual({
                      index: individualIndex,
                      data: {
                        id: selectedIndividual.id,
                        personalDetails,
                      },
                    })
                  );
                  setIsEditSummary(false);
                  dialog.hide()
                }}
                size="large"
              />}




            </div>
          </div>
        </DialogFooter>
      </Dialog>
    </DialogBackdrop>
  );
};

export default IndividualModal;
